import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometwelve-blog',
  templateUrl: './hometwelve-blog.component.html',
  styleUrls: ['./hometwelve-blog.component.scss']
})
export class HometwelveBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
